import { useCallback, useState } from 'react';
import { uploadPixVerificationDocument } from '@/lib/pixVerification/uploadDocument';

export function usePixVerificationDocumentUpload() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadDocument = useCallback(async (file: File): Promise<string | null> => {
    setIsLoading(true);
    setError(null);

    try {
      return await uploadPixVerificationDocument(file);
    } catch (uploadError) {
      setError(
        uploadError instanceof Error
          ? uploadError.message
          : 'pix_verification_document_upload_failed',
      );
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { uploadDocument, isLoading, error };
}
